module.exports = {
	colors: {
		main: '#03a58f',
		sec: '#ea7583',
		alt: '#03a58f',
	},

	showFunds: false,
	showBuses: true,
	showHomeworks: true,
	showSchoolDay: true,
	useCourses: false,
	useUploadChatImage: false,

	about: {
		mobiles: ['+963989802034', '+963989802037', '+963948889666'],
		phones: [],
		address: '',
		data: [],
		email: null,
		facebook: 'https://www.facebook.com/profile.php?id=100063896384736',
		privacy: null,
		details: [],
	},

	pwa: {
		name: 'Motherland school',
		shortName: 'Motherland school',
		description: 'Motherland school app - portal version for Motherland school mobile app.',
	},
};
